<script setup lang="ts">
import { DropdownMenuRadioItem } from 'reka-ui';
import Icon from '../icon/icon.vue';
import { IconSize } from '../icon/icon.constants';
import type { MenuItem } from './menu.types';
import {
  menuItemBaseClass,
  menuItemIconClass,
  menuItemRegularClass,
  menuItemSelectedClass,
} from './menu.styles';

type Props = {
  item: MenuItem & { value: string };
};

const props = defineProps<Props>();
</script>

<template>
  <DropdownMenuRadioItem
    :value="props.item.value"
    :disabled="props.item.disabled"
    :text-value="props.item.label"
    :class="[menuItemBaseClass, menuItemRegularClass, menuItemSelectedClass]"
    @select="props.item.onSelect?.($event)"
  >
    <Icon
      v-if="props.item.leftIconName"
      :name="props.item.leftIconName"
      :size="IconSize.MD"
      :class="menuItemIconClass"
    />
    <span class="min-w-0 flex-1">
      <slot>
        <span class="block wrap-break-word">{{ props.item.label }}</span>
      </slot>
    </span>
  </DropdownMenuRadioItem>
</template>
